import React, { Component } from 'react';
import axios from 'axios';

class GptTestPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      systemPrompt: "너는 인스타그램 피드 문구 전문가다...",
      userPrompt: "",
      selectedFile: null,
      previewUrl: null,
      results: "",
      isLoading: false,
      model: "gpt-5", // 기본 모델 설정
    };
  }

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      this.setState({
        selectedFile: file,
        previewUrl: URL.createObjectURL(file)
      });
    }
  };

  handleSubmit = async () => {
    const { systemPrompt, userPrompt, selectedFile } = this.state;

    // 1. 벨리데이션 체크
    if (!systemPrompt.trim()) {
      alert("시스템 프롬프트를 입력해주세요. GPT에게 역할을 부여해야 합니다!");
      return;
    }

    if (!userPrompt.trim() && !selectedFile) {
      alert("유저 프롬프트(텍스트)나 이미지 중 최소 하나는 입력해야 합니다.");
      return;
    }

    // (선택사항) 이미지 용량 제한 체크 - 예: 5MB
    // if (selectedFile && selectedFile.size > 5 * 1024 * 1024) {
    //   alert("이미지 파일이 너무 커요! 5MB 이하의 파일을 선택해주세요.");
    //   return;
    // }
    
    // 2. 통과 시 로딩 시작
    this.setState({ isLoading: true });

    const formData = new FormData();
    formData.append('systemPrompt', systemPrompt);
    formData.append('userPrompt', userPrompt);
    formData.append('model', this.state.model); // 모델명  전송
    if (selectedFile) {
      formData.append('image', selectedFile);
    }

    try {
        const response = await axios.post('/rest/admin/gpt/test', formData);

        if (response.data.code === 200) {
        // 이제 results에는 문자열이 담깁니다.
        this.setState({ results: response.data.data });
        } else {
        alert("오류 발생: " + response.data.error_msg);
        }
    } catch (error) {
        console.error(error);
    } finally {
        this.setState({ isLoading: false });
    }
  };

  render() {
    return (
        <div id='page-wrapper' className="container">
            <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
                <h2>GPT API Test</h2>

                {/* 모델 선택 셀렉트 박스 */}
                <div style={{ marginBottom: '15px' }}>
                    <label>Model Select: </label>
                    <select 
                    name="model" 
                    value={this.state.model} 
                    onChange={this.handleInputChange}
                    style={{ padding: '5px', marginLeft: '10px', paddingRight: 30 }}
                    >
                    <option value="gpt-5">GPT-5</option>
                    <option value="gpt-4o">GPT-4o</option>
                    </select>
                </div>
                
                <div style={{ marginBottom: '15px' }}>
                <label>System Prompt:</label>
                <textarea 
                    name="systemPrompt"
                    value={this.state.systemPrompt} 
                    onChange={this.handleInputChange}
                    style={{ width: '100%', height: '100px', display: 'block' }}
                />
                </div>

                <div style={{ marginBottom: '15px' }}>
                <label>User Prompt (Text):</label>
                <textarea 
                    name="userPrompt"
                    value={this.state.userPrompt} 
                    onChange={this.handleInputChange}
                    style={{ width: '100%', height: '80px', display: 'block' }}
                />
                </div>

                <div style={{ marginBottom: '15px' }}>
                <label style={{ marginRight: 5}}>User Image:</label>
                <input type="file" accept="image/*" onChange={this.handleFileChange} />
                {this.state.previewUrl && (
                    <img src={this.state.previewUrl} alt="Preview" style={{ width: '100px', marginTop: '10px', display: 'block' }} />
                )}
                </div>

                <div style={{display: "flex", justifyContent: "right"}}>
                    <button 
                    onClick={this.handleSubmit} 
                    disabled={this.state.isLoading}
                    style={{ padding: '10px 20px', cursor: 'pointer', color: '#202020', backgroundColor: this.state.isLoading ? '#ccc' : '#00e2e6', border: 'none', borderRadius: '6px' }}
                    >
                    {this.state.isLoading ? '호출 중...' : 'API 호출'}
                    </button>
                </div>
                <hr />

                <h3>결과:</h3>
                {/* {this.state.results.map((res, idx) => (
                <div key={idx} style={{ border: '1px solid #ddd', padding: '10px', marginBottom: '10px' }}>
                    <strong>[{res.label}]</strong>
                    <p>{res.text}</p>
                </div>
                ))} */}
                <div style={{ border: '1px solid #ddd', padding: '10px', marginBottom: '10px' }}>
                    <p>{this.state.results}</p>
                </div>
            </div>
        </div>
    );
  }
}

export default GptTestPage;